Object.defineProperty(exports,"__esModule",{value:true});var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[typeof Symbol==='function'?Symbol.iterator:'@@iterator'](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if((typeof Symbol==='function'?Symbol.iterator:'@@iterator')in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();exports.






mergePayload=mergePayload;exports.










translatePayload=translatePayload;exports.default=










pageStateMethod;var _makeClassMemberDecorator=require('./makeClassMemberDecorator');var _makeClassMemberDecorator2=_interopRequireDefault(_makeClassMemberDecorator);var _merge=require('lodash/merge');var _merge2=_interopRequireDefault(_merge);var _has=require('lodash/has');var _has2=_interopRequireDefault(_has);var _isEmpty=require('lodash/isEmpty');var _isEmpty2=_interopRequireDefault(_isEmpty);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function mergePayload(path){var _payload=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var _mergedPayload=arguments[2];var props=arguments[3];var payload=typeof _payload==='function'?_payload(props):_payload;var mergedPayload=typeof _mergedPayload==='function'?_mergedPayload(props):_mergedPayload;return[path,(0,_merge2.default)({},payload,{payload:mergedPayload})];}function translatePayload(config,props){if(typeof config==='string'){return[config,{}];}var _translatePayload=translatePayload(config.path),_translatePayload2=_slicedToArray(_translatePayload,2),path=_translatePayload2[0],payload=_translatePayload2[1];return mergePayload(path,payload,config.payload,props);}function pageStateMethod(){var config=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _ref=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},callback=_ref.callback;
return(0,_makeClassMemberDecorator2.default)(
function(decoratedFn){return(
function decorateClassMember(){var _this=this,_arguments=arguments;
return new Promise(function(resolve,reject){
if(!(0,_has2.default)(_this.props,'setPageState')){
reject('Component didn\'t have decorator pageState.');
}
var args=null;

var loadingConfigs=(Array.isArray(config.loading)?config.loading:[config.loading]).filter(Boolean);
var errorConfigs=(Array.isArray(config.error)?config.error:[config.error]).filter(Boolean);
var successConfigs=(Array.isArray(config.success)?config.success:[config.success]).filter(Boolean);

_this.props.resetPageState();

var promiseFn=new Promise(function(resolve,reject){
var fn=function fn(){
var fnResult=decoratedFn.apply(_this,_arguments);
if(fnResult&&fnResult.then)fnResult.then(resolve).catch(reject);else
{
resolve(fnResult);
}
};
if(callback)return callback().then(fn);
return fn();
});

if(!(0,_isEmpty2.default)(loadingConfigs)){
loadingConfigs.forEach(function(loadingConfig){var _props;

args=translatePayload(loadingConfig,_this.props);
(_props=_this.props).setPageState.apply(_props,_toConsumableArray(args));
});
}


return promiseFn.then(function(result){
_this.props.resetPageState();

if(!(0,_isEmpty2.default)(successConfigs)){
successConfigs.forEach(function(successConfig){var _props2;

args=translatePayload(successConfig,_this.props);
(_props2=_this.props).setPageState.apply(_props2,_toConsumableArray(mergePayload.apply(undefined,_toConsumableArray(args).concat([{
result:result}]))));

});
}
resolve(result);
}).catch(function(e){

_this.props.resetPageState();
var retryFn=decorateClassMember.bind(_this);
if(!(0,_isEmpty2.default)(errorConfigs)){

errorConfigs.forEach(function(errorConfig){var _props3;
args=translatePayload(errorConfig,_this.props);

(_props3=_this.props).setPageState.apply(_props3,_toConsumableArray(
mergePayload.apply(undefined,_toConsumableArray(args).concat([{
error:e,
retry:function retry(){return retryFn.apply(_this,_arguments);}}]))));


});
resolve();
}else{
reject(e);
}
});
});
});});

}